"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_type_1 = require("./is-type");
var isRegExp = function (str) {
    return is_type_1.default(str, 'RegExp');
};
exports.default = isRegExp;
//# sourceMappingURL=is-reg-exp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-reg-exp.js
// module id = 1126
// module chunks = 37